import { Children } from "react"

export const StandardComp = ({content,onClick,style,editClass,children, key= "",editable = false}) => {
    return(
        <div onClick={onClick} className={`standard-comp ${editClass}`} style={style} key={key} editable ={editable} >
            {content}{children}
        </div>
    ) 
}